import { createContext } from 'react';
import { DefaultCartContext, ICartContext } from './CartContext.types';

export const CartContext = createContext<ICartContext>(DefaultCartContext());
